import { IsString } from "class-validator";

export class ContractNoteDto {
  @IsString()
  note: string;
}
